import { customizeYup } from '@shared/components/forms/shared/validation/customize-yup'
import { Step2FormModel } from '@shared/components/forms/sign/steps/step2/form/model'
import { object, string } from 'yup'

customizeYup()

export const step2ValidationSchema = object<Step2FormModel>({
	code: string(),
	consentTypes: object(),
})
